import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}

export default function ArticleSection() {
  const latest = articles.slice(4, 10);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              最新资讯
            </h2>
            <p className="text-foreground-600 text-sm">最新最热的视频内容，每日更新</p>
          </div>
          <Link
            to="/category/entertainment"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 bg-background-50 border border-background-200/70 rounded-2xl p-4 hover:border-primary-200 transition-all duration-300 hover:-translate-y-0.5"
            >
              <div className="w-28 h-20 md:w-36 md:h-24 flex-shrink-0 rounded-xl overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium mb-1.5">
                    {article.categoryName}
                  </span>
                  <h3 className="font-heading text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400 mt-2">
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    {formatViews(article.views)}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}